<template>
  <div class="content-wrapper">
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="breadcrumbs-top">
          <h5 class="content-header-title float-left pr-1 mb-0"> {{ title }}</h5>
          <div class="breadcrumb-wrapper d-none d-sm-block">
            <ol class="breadcrumb p-0 mb-0 pl-1">
              <li class="breadcrumb-item">
                <router-link :to="'/'" class="subheader-breadcrumbs-home">
                  <i class="bx bx-home-alt"></i>
                </router-link>
              </li>
              <template v-for="(breadcrumb, i) in breadcrumbs">
                <li :key="`${i}-${breadcrumb.id}`" :class="i > 0 ? 'active' : ''" class="breadcrumb-item ">
                  <router-link
                      v-if="breadcrumb.route"
                      :key="i"
                      :to="breadcrumb.route"
                      class="text-muted"
                  >
                    {{ breadcrumb.title }}
                  </router-link>
                  <span v-if="!breadcrumb.route" :key="i">
                {{ breadcrumb.title }}
              </span>
                </li>
              </template>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    title: String
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
  }
};
</script>
